import React, { createContext } from 'react'
import { useKeycloak } from '@react-keycloak/web'
import UserServices from './Services/Consumers/UserServices'
import SubscriptionServices from './Services/Consumers/SubscriptionServices'
import { useIntl } from 'react-intl'
import { filterData } from './utils/helpers'

const UserContext = createContext({})

const UserProvider = ({ children, uid, adminSectionType, handleNotificationCall }) => {
  const { keycloak } = useKeycloak()
  const intl = useIntl()
  const [selectedUserDataLoading, setSelectedUserDataLoading] = React.useState(false)
  const [selectedUserDataFailure, setSelectedUserDataFailure] = React.useState(false)
  const [selectedUserData, setSelectedUserData] = React.useState({})

  const [updateSelectedUserProfileFailure, setUpdateSelectedUserProfileFailure] = React.useState(false)
  const [updateSelectedUserProfileSuccess, setUpdateSelectedUserProfileSuccess] = React.useState(false)

  const getSelectedUserData = React.useCallback(() => {
    if (!!keycloak?.authenticated) {
      setSelectedUserDataFailure(false)
      setSelectedUserDataLoading(true);
      ('subscription' === adminSectionType ? SubscriptionServices : UserServices).getUserProfileData(uid, { headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` } }).then((result) => {
        if (!!result && !!result.data && !!result.data.data) {
          let rolesIds = (!!result.data.data.roles && !!result.data.data.roles.length) ?
            result.data.data.roles.map(role => role.id) : []
          setSelectedUserData({ ...result.data.data, 'rolesIds': rolesIds })
        } else {
          setSelectedUserDataFailure(true)
        }
      }).then(() => {
        setSelectedUserDataLoading(false)
      })
    }
  }, [keycloak, uid, adminSectionType])


  const updateUserAdditionalInfo = (values, FormikActions) => {
    if (!!keycloak?.authenticated) {
      setUpdateSelectedUserProfileFailure(false)
      setUpdateSelectedUserProfileSuccess(false)
      FormikActions.setSubmitting(true)
      let data = {}
      if ('subscription' === adminSectionType) {
        data = {
          'active': values.active,
          'roles': values.roles
        }

      } else {
        data = {
          'active': selectedUserData.active,
          'address_line1': values.address_line1.toString(),
          'address_line2': values.address_line2.toString(),
          'roles': values.roles,
          'country_id': parseInt(values.country),
          'government_id': parseInt(values.government) || '',
          'city_id': parseInt(values.city) || '',
          'national_id': values.socialNumber.toString(),
          'contact_channel': values.contactChannel.toString()
        }
      }
      ('subscription' === adminSectionType ? SubscriptionServices : UserServices).updateUserProfileData(uid, filterData(data), { headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` } },
        FormikActions.setSubmitting, setUpdateSelectedUserProfileFailure, FormikActions).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          setUpdateSelectedUserProfileFailure(true)
        } else {
          if (!!result && !!result.data && !!result.data.data) {
            setUpdateSelectedUserProfileSuccess(true)
          }
        }
      }).then(() => {
        FormikActions.setSubmitting(false)
      })
    }
  }

  const sendResetPasswordOTP = () => {
    if (!!keycloak?.authenticated) {
      ('subscription' === adminSectionType ? SubscriptionServices : UserServices).sendResetPasswordOTP(uid, { headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` } }).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          let message = intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' })
          if (result.response.data && result.response.data.status && result.response.data.status.message) {
            message = result.response.data.status.message
          }
          handleNotificationCall({
            type: 'defence',
            message: message,
            color: 'error'
          }, 'error')
        } else {
          if (!!result && !!result.data && !!result.data.data) {
            handleNotificationCall({
              type: 'message',
              message: intl.formatMessage({ id: 'Users.List.Table.sendResetPasswordOTP.Success' }),
              color: 'success'
            }, 'success')
          } else {
            handleNotificationCall({
              type: 'defence',
              message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
              color: 'error'
            }, 'error')
          }
        }
      })
    }
  }

  return (
    <UserContext.Provider value={{
      selectedUserDataLoading: selectedUserDataLoading,
      selectedUserDataFailure: selectedUserDataFailure,
      selectedUserData: selectedUserData,
      getSelectedUserData,

      updateSelectedUserProfileSuccess: updateSelectedUserProfileSuccess,
      updateSelectedUserProfileFailure: updateSelectedUserProfileFailure,
      updateUserAdditionalInfo,

      sendResetPasswordOTP
    }}>
      {children}
    </UserContext.Provider>
  )
}
const UserConsumer = UserContext.Consumer

export { UserProvider, UserConsumer }
